var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
export var defaultTimeOutMillis = 30000;
/**
 * Generic wrapper for Fetch which will reject on timeOut
 */
export var fetchWithTimeOut = function (url, options, timeOut) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, Promise.race([
                fetch(url, options).then(function (response) { return response; }),
                new Promise(function (_, reject) {
                    return setTimeout(function () { return reject(new Error("The request timed out")); }, timeOut);
                }),
            ])];
    });
}); };
/**
 * Custom wrapper for Fetch to abstract error handling and JSON parsing
 */
export var fetchJSON = function (url, options, timeOut) { return __awaiter(void 0, void 0, void 0, function () {
    var response, meta, text, json;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchWithTimeOut(url, options, timeOut)];
            case 1:
                response = _a.sent();
                meta = response.clone();
                return [4 /*yield*/, response.text()];
            case 2:
                text = _a.sent();
                json = "";
                try {
                    json = JSON.parse(text);
                }
                catch (error) {
                    json = text;
                }
                return [2 /*return*/, meta.ok
                        ? { meta: meta, json: json }
                        : Promise.reject({ meta: meta, json: json })];
        }
    });
}); };
/**
 * Returns a default options object to use for requests
 */
export var setFetchOpts = function (_a) {
    var _b;
    var method = _a.method, headers = _a.headers, body = _a.body;
    var headersToUse = new Headers(__assign((_b = { Accept: "application/json" }, _b["Content-Type"] = "application/json", _b), headers));
    var fetchOpts = {
        method: method,
        credentials: "include",
        headers: headersToUse,
        body: body && method !== "GET" /* requestMethods.GET */ ? JSON.stringify(body) : undefined,
    };
    return fetchOpts;
};
/**
 * Generic timer to add timeout functionality to fetch requests
 */
export var timer = function (delay) {
    return new Promise(function (resolve) { return setTimeout(resolve, delay); });
};
/**
 * Returns common headers used in fetch requests by services
 */
export var getStandardServiceHeaders = function (_a) {
    var csrfToken = _a.csrfToken, etag = _a.etag, propertyToUse = _a.propertyToUse;
    var headers = {};
    if (csrfToken)
        headers["csrf-token"] = csrfToken;
    if (etag) {
        var etagValue = typeof etag === "object" ? etag[propertyToUse] : etag;
        headers["If-Match"] = etagValue;
    }
    return headers;
};
